import api from '@/services/api'

export default {
  /**
   * log in user with credentials
   * @param {String} username 
   * @param {String} password 
   * @return {Object} user
   */
  async login (username, password) {
    try {
      const res = await api.post('/login', {
        username: username,
        password: password
      })
      return res.data
    } catch (error) {
      if (error.response.status === 401) {
        throw 'bad credentials'
      }
      throw `Auth api service ${error}`
    }
  },

  async logout () {
    try {
      await api.get('/logout')
    } catch (error) {
      throw `Auth api service ${error}`
    }
  }
}
